import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { TypeUtils } from '../../../framework/utils/UtilityTypes';
import { DeadlineSearchParam } from '../../models/gen/deadlineSearchParam';
import { DeadlineSearchResult } from '../../models/gen/deadlineSearchResult';
import { useGenericQuery } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const DEADLINE_CONTEXT_NAMES = {
  POST_DEADLINE_SEARCH: 'searchDeadline',
} as const;

const apis = apiGenerator();

/**
 * POST `/deadline/search`
 *
 * @param param -
 * @returns
 */
export const usePostDeadlineSearch = (
  param: DeadlineSearchParam,
  pollingInterval?: number
) =>
  useGenericQuery(
    [
      DEADLINE_CONTEXT_NAMES.POST_DEADLINE_SEARCH,
      param as Record<string, unknown>,
    ],
    async (_param) =>
      apis.post<DeadlineSearchParam, DeadlineSearchResult>(
        `${env.BASE_API_ENDPOINT}/deadline/search`,
        { ...queryOptions, data: param }
      ),
    {
      enabled: false,
      refetchInterval: TypeUtils.isNil(pollingInterval)
        ? false
        : pollingInterval * 1000,
      refetchIntervalInBackground: true,
      staleTime: 0,
    }
  );
